import { getSelectedDevEnv } from '../getUrl';
import classNames from 'classnames';
import style from './EnvSwitcher.module.scss';

function EnvSwitcher() {
  const selectedEnv = getSelectedDevEnv();
  const selectableApisRaw = import.meta.env.VITE_SELECTABLE_API_ENVS;
  const selectableApis = selectableApisRaw
    ? selectableApisRaw.split(',')
    : ['VITE_SELECTABLE_API_ENVS missing'];

  const handleSelect = (env: string) => {
    localStorage.setItem('qaSelectedEnv', env);
    window.location.reload();
  };

  if (!selectableApisRaw) return null;

  return (
    <div className={style.wrapper}>
      <div className={style.line}>
        Selected API env: <span className={style.selected}>{selectedEnv}</span>
      </div>
      <div className={classNames(style.line, style.items)}>
        {selectableApis.map((env: string) => (
          <span
            key={env}
            onClick={() => handleSelect(env)}
            className={classNames(
              style.item,
              env === selectedEnv && style['item-selected'],
            )}
          >
            {env}
          </span>
        ))}
      </div>
    </div>
  );
}

export default EnvSwitcher;
